import { useEffect, useState } from 'react'
import {
  EditRounded,
  ApartmentRounded
} from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select
} from '@mui/material'
import { useAuth } from '../../providers/auth'
import { socket } from '../..'
import { useTheme } from '../../providers/theme'

export default function AccountAdmins() {
  const {user, currentRole} = useAuth()
  const [dialog, setDialog] = useState<boolean>(false)
  const {mode} = useTheme()
  const [companies, setCompany] = useState<string>(user!.companies)
  const [tempCompany, setTempCompany] = useState<string>(companies)
  const [distributors, setDistributors] = useState<string[]>([])

  useEffect(() => {
    socket.emit('get_distributors');
    socket.on('distributors_received', (data) => {
      if (data.error) {
        console.error(data.error)
      } else {
        setDistributors(data.distributors.sort())
      }
    })
    return () => {
      socket.off('distributors_received')
    }
  }, [])

  return (
    currentRole !== undefined && currentRole.includes('Administrator') ?
      <>
        <Divider
          style={{
            width: "80%",
            backgroundColor: "#888",
            border: "1px solid #888",
            borderRadius: "1px"
          }}
        />
        <Box mt={2} sx={{ width: "80%" }}>
          <List 
            subheader={
              <ListSubheader
                disableSticky
                sx={{ backgroundColor: 'transparent' }}
              >
                Administrators
              </ListSubheader>
            }
          >
            <ListItem
              secondaryAction={
                <IconButton edge="end" aria-label="edit name" onClick={() => setDialog(true)}>
                  <EditRounded />
                </IconButton>
              }
            >
              <ListItemIcon>
                <ApartmentRounded />
              </ListItemIcon>
              <ListItemText
                sx={{ whiteSpace: "pre-line" }}
                primary={`${user!.companies ? user!.companies.split(";").join("\n") : "None"}`}
              />
            </ListItem>
          </List>
          <Dialog
            fullWidth
            maxWidth="xs"
            open={dialog}
            PaperProps={{
              style: {
                backgroundColor: mode === 'light' ? "#f6f6f6" : "#151515",
                borderRadius: "10px",
                boxShadow: mode === 'light' ? "0px 3px 12px -1px rgba(0, 0, 0, 0.2)" : "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
              }
            }}
            onClose={() => setDialog(false)}
          >
            <DialogTitle id="alert-dialog-title">
              Select companies
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Select the companies you work for from the list.
              </DialogContentText>
              <FormControl
                sx={{
                  width: "100%",
                  mt: 3,
                  mb: 3
                }}
              >
                <Select
                  multiple={true}
                  value={tempCompany ? tempCompany.split(';') : []}
                  onChange={(event) => {
                    const { target: { value } } = event
                    setTempCompany(typeof value === 'string' ? value : value.join(';'))
                  }}
                  input={<OutlinedInput />}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: mode === 'light' ? "#fff" : "#151515",
                        borderRadius: '10px',
                        '&::-webkit-scrollbar': {
                          width: ".3em",
                        },
                        '&::-webkit-scrollbar-track': {
                          background: "transparent",
                          boxShadow: "inset 0 0 10px #1c1c1c",
                          borderRadius: "5px",
                          borderLeft: "1px solid transparent",
                          borderRight: "1px solid transparent",
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#444',
                          outline: '1px solid #444',
                          borderRadius: ".15em"
                        }
                      }
                    }
                  }}
                >
                  {
                    distributors !== undefined ?
                      distributors.map((item: string) => (
                        <MenuItem
                          key={item}
                          value={item}
                          sx={{
                            "&.Mui-selected": {
                              backgroundColor: "rgba(133, 210, 1, 0.3)",
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: "rgba(133, 210, 1, 0.3)",
                            },
                            "&:hover": {
                              backgroundColor: `${mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`
                            }
                          }}
                        >
                          {item}
                        </MenuItem>
                      ))
                    : null
                  }
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setTempCompany(companies)
                  setDialog(false)
                }}
                color="error"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setCompany(tempCompany)
                  socket.emit('set_company', user!.uid, tempCompany || "")
                  setDialog(false)
                }}
                autoFocus
                color="secondary"
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </>
    : null
  )
}